const { useEffect, useState } = wp.element;

function WPAPIService(url) {
  const [data, setData] = useState(null);
  const [totalPages, setTotalPages] = useState(null);
  const [totalPosts, setTotalPosts] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    async function loadData() {
      const response = await fetch(url);
      if (!response.ok) {
        // oups! something went wrong
        return;
      }

      const posts = await response.json();
      setTotalPages(response.headers.get("X-WP-TotalPages"));
      setTotalPosts(response.headers.get("X-WP-Total"));
      setLoading(false);
      setData(posts);
    }

    loadData();
  }, [url]);
  return [data, totalPages, totalPosts, loading];
}
export default WPAPIService;



// WEBPACK FOOTER //
// ./react/wp-rest/posts.jsx